(function () {
  if (document.documentElement.hasAttribute('data-size-chart-popup-ready')) return;
  document.documentElement.setAttribute('data-size-chart-popup-ready', 'true');

  var activeModal = null;
  var activeTrigger = null;
  var activePlaceholder = null;

  function moveModalToBody(modal) {
    if (!modal || modal.parentNode === document.body) return null;

    var placeholder = document.createComment('size-chart-popup-placeholder');
    modal.parentNode.insertBefore(placeholder, modal);
    document.body.appendChild(modal);
    return placeholder;
  }

  function restoreModalPosition() {
    if (activeModal && activePlaceholder && activePlaceholder.parentNode) {
      activePlaceholder.parentNode.insertBefore(activeModal, activePlaceholder);
      activePlaceholder.parentNode.removeChild(activePlaceholder);
    }
    activePlaceholder = null;
  }

  function openModal(trigger) {
    var modalId = trigger.getAttribute('data-size-chart-open');
    var modal = document.getElementById(modalId);
    if (!modal) return;

    closeModal();
    activePlaceholder = moveModalToBody(modal);
    activeModal = modal;
    activeTrigger = trigger;

    activeModal.classList.add('is-open');
    activeModal.setAttribute('aria-hidden', 'false');
    trigger.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('m-size-chart-popup-lock');

    var dialog = activeModal.querySelector('.m-size-chart-popup__dialog');
    if (dialog) {
      window.setTimeout(function () { dialog.focus(); }, 30);
    }
  }

  function closeModal() {
    if (!activeModal) return;

    activeModal.classList.remove('is-open');
    activeModal.setAttribute('aria-hidden', 'true');

    if (activeTrigger) {
      activeTrigger.setAttribute('aria-expanded', 'false');
      activeTrigger.focus({ preventScroll: true });
    }

    document.documentElement.classList.remove('m-size-chart-popup-lock');
    restoreModalPosition();
    activeModal = null;
    activeTrigger = null;
  }

  document.addEventListener('click', function (event) {
    var openBtn = event.target.closest('[data-size-chart-open]');
    if (openBtn) {
      event.preventDefault();
      openModal(openBtn);
      return;
    }

    if (event.target.closest('[data-size-chart-close]')) {
      event.preventDefault();
      closeModal();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeModal();
    }
  });
})();